import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

type Props = {
  rows?: number
  showToolbar?: boolean
  showPagination?: boolean
  className?: string
}

const ListingPageSkeleton = ({
  rows = 10,
  showToolbar = false,
  showPagination = true,
  className = '',
}: Props) => (
  <SkeletonTheme
    baseColor='var(--ss-skeleton-base, #e9ecef)'
    highlightColor='var(--ss-skeleton-highlight, #f5f8fa)'
    borderRadius={6}
    duration={1.4}
  >
    <div
      className={`ss-listing-skeleton ${className}`.trim()}
      aria-busy='true'
      aria-label='Loading content'
    >
      {showToolbar && (
        <div className='ss-listing-skeleton__toolbar'>
          <div className='ss-listing-skeleton__toolbar-tabs'>
            {[108, 92, 118, 104, 88, 72, 64].map((width) => (
              <Skeleton key={width} width={width} height={32} />
            ))}
          </div>
          <div className='ss-listing-skeleton__toolbar-actions'>
            <Skeleton width={140} height={32} />
            <Skeleton width={110} height={32} />
          </div>
        </div>
      )}

      <div className='ss-listing-skeleton__table'>
        <div className='ss-listing-skeleton__thead'>
          <Skeleton width={16} height={16} />
          <Skeleton width={48} height={12} />
          <Skeleton width={72} height={12} />
          <Skeleton containerClassName='ss-listing-skeleton__thead-grow' height={12} />
          <Skeleton width={36} height={12} />
          <Skeleton width={36} height={12} />
        </div>

        {Array.from({ length: rows }).map((_, index) => (
          <div className='ss-listing-skeleton__row' key={`sk-row-${index}`}>
            <Skeleton width={16} height={16} />
            <Skeleton width={52} height={14} />
            <Skeleton containerClassName='ss-listing-skeleton__row-grow' height={14} />
            <Skeleton circle width={30} height={30} />
            <Skeleton width={44} height={14} />
            <Skeleton width={18} height={18} />
          </div>
        ))}
      </div>

      {showPagination && (
        <div className='ss-listing-skeleton__pagination'>
          <Skeleton width={72} height={30} />
          <Skeleton width={130} height={30} />
        </div>
      )}
    </div>
  </SkeletonTheme>
)

export default ListingPageSkeleton
